import { ApplicationView, useController } from '@aha-app/mvc';
import React from 'react';
import { type FieldInputProps } from '.';
import FieldsController from '../../../controllers/FieldsController';
import EditableTextField from '../../EditableTextField';

const EditTextInput: React.FC<FieldInputProps> = ({
  field,
  objects,
  sameValue,
  value,
}) => {
  const controller = useController(FieldsController);

  return (
    <EditableTextField
      initialValue={value}
      onChange={value =>
        controller.actionUpdateObjectsField(objects, field, value)
      }
      placeholder={sameValue ? 'Click to add text' : 'Multiple values'}
    />
  );
};

export default ApplicationView(EditTextInput);
